<template>
  <tr>
    <td>
      <button class="btn btn-icon btn-xs btn-light-primary" @click="$root.$emit('detail', row)">
        <i class="fa fa-eye"></i>
      </button>
      <button class="btn btn-icon btn-xs btn-light-warning ml-1" @click="$emit('edit', row)">
        <i class="fa fa-pen"></i>
      </button>
      <button class="btn btn-icon btn-xs btn-light-danger ml-1" @click="$emit('delete', row)">
        <i class="fa fa-trash-alt"></i>
      </button>
    </td>
    <td class="text-center align-middle">
      <input v-if="!row.tieneFactura" type="checkbox" name="" id="" v-model="row.checked" :disabled="!esCheckeable" />
    </td>
    <td class="text-center">
      {{ row.codigo }}
      <!-- {{ esCheckeable }} -->
    </td>
    <td class="text-center">
      {{ row.fechaHora | date }}
    </td>
    <td class="text-center">
      {{ row.modulo }}
    </td>
    <td class="text-center">
      {{ row.codRegistro }}
    </td>
    <td>
      {{ row.agencia }}
    </td>
    <td>
      {{ row.pasajero }}
    </td>
    <td class="text-center">
      {{ row.servicios }}
    </td>
    <td class="text-center">
      {{ row.pax }}
    </td>
    <td class="text-center">
      {{ row.chd }}
    </td>
    <td class="text-center">
      {{ row.moneda }}
    </td>
    <td class="text-center">
      {{ row.suma | number(2) }}
    </td>
    <td class="text-center">
      {{ row.usuarioCreador }}
    </td>
    <td class="text-center">
      {{ row.usuarioModif }}
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
// import InputText from "../../shared/components/InputText.vue";
// import InputTextArea from "../../shared/components/InputTextArea.vue";
export default {
  // components: { InputTextArea, InputText },
  props: {
    row: Object,
  },
  computed: {
    esCheckeable() {
      if (!this.grupo.agencia) return true;

      if (this.grupo.agencia == this.row.idAgencia && this.grupo.moneda == this.row.moneda) return true;

      return false;
    },
    ...mapGetters("liquidaciones", ["grupo"]),
  },
  watch: {
    "row.checked"(val, oldVal) {
      this.$store.dispatch("liquidaciones/check", {
        agencia: this.row.idAgencia,
        moneda: this.row.moneda,
        checked: val,
      });
    },
  },
};
</script>

<style></style>
